import LanguageManager from '../language_manager/language_manager';
import config from '../../config';
import DomUtils from '../../util/dom_utils';
import Youbora from '../report/youbora';
import safe from '../../util/safe';

export const BackButton = {
    init(adapter, emitter) {
        DomUtils.waitForElement('class', 'bitdash-ctrl', (success, playerControlsElement) => {
            let backButtonElement = DomUtils.createElementFromString(require('./back_button.hbs')({back_text: LanguageManager.get('back')}));
            backButtonElement.onclick = () => {
                safe.code(() => Youbora.stopSending());
                if (adapter && adapter.pause) {
                    adapter.pause();
                }
                if (emitter) {
                    emitter.emit('player-exit');
                }
                DomUtils.destroyElement(document.getElementById(config.playerElementId));
                
                if (!!window.sessionStorage) {
                    sessionStorage.setItem('video-quality', 'auto');
                }

                setTimeout(() => window.history.back(), 300);
            };
            playerControlsElement.parentNode.insertBefore(backButtonElement, playerControlsElement.nextSibling);
        }, {timeout: 3600000}); // try for 1 hour
    }
};

export default BackButton;



// WEBPACK FOOTER //
// ./src/modules/backbutton/back_button.js